<template>
  <div>
    <b-modal
      id="modal-share"
      ref="modal-share"
      :title="$t('liveView.placeholder.shareLocation')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.cancel')"
      ok-variant="outline-primary"
      ok-only
      size="md"
      centered
      modal-class="mc-modal-share"
    >
      <p>
        {{ $t('liveView.text.configureGps') }}
        <strong class="font-weight-bold">
          {{
            `${item.licensePlate} / ${item.vehicle?.vehicleType?.type ?? '-'} / ${
              item.vehicle?.vehicleType?.category ?? '-'
            }`
          }}
        </strong>
      </p>
      <b-list-group>
        <b-list-group-item href="#" @click="share('copy')">
          <i class="fas fa-link me-1"></i> {{ $t('global.action.copyLink') }}
        </b-list-group-item>
        <b-list-group-item href="#" @click="share('wa')">
          <i class="fab fa-whatsapp me-1"></i> {{ $t('global.action.share.wa') }}
        </b-list-group-item>
        <b-list-group-item
          v-if="
            hasAccessAll([
              'temporary_live_views:create',
              'temporary_live_views:read',
              'share_temporary_live_views:read',
            ])
          "
          href="#"
          @click="share('tempTracker')"
        >
          <i class="icon-outline_car me-1"></i>
          {{ $t('global.action.share.tempTracker') }}
        </b-list-group-item>
      </b-list-group>
    </b-modal>
    <ModalTempTracking
      v-if="
        hasAccessAll([
          'temporary_live_views:create',
          'temporary_live_views:read',
          'share_temporary_live_views:read',
        ])
      "
      :licensePlate="item.licensePlate"
      :vehicleId="item.vehicleId"
      @setAccessToken="setAccessToken"
    />
    <ModalTempTrackingResult
      v-if="
        hasAccessAll([
          'temporary_live_views:create',
          'temporary_live_views:read',
          'share_temporary_live_views:read',
        ])
      "
      :tempTracking="tempTracking"
    />
  </div>
</template>
<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import ModalTempTracking from './ModalTempTracking'
import ModalTempTrackingResult from './ModalTempTrackingResult'

export default {
  components: {
    ModalTempTracking,
    ModalTempTrackingResult,
  },
  mixins: [Helper, MixPanel],
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tempTracking: {
        accessToken: '',
        temporaryLvId: 0,
        shortKey: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    share(param) {
      if (param === 'wa') {
        this.track('Share Fleet Location Via Whatsapp')
        window.open(
          'https://wa.me/?text=_Location from vehicle *' +
            this.item.licensePlate +
            '* http%3A%2F%2Fmaps.google.com%2Fmaps%3F%26z%3D15%26mrt%3Dyp%26t%3Dm%26q%3D' +
            this.item.latitude +
            '%2B' +
            this.item.longitude,
          '_blank'
        )
      } else if (param === 'copy') {
        this.track('Share Fleet Location Via Copy Link')
        let url = `http://maps.google.com/maps?&z=15&mrt=yp&t=m&q=${this.item.latitude},${this.item.longitude}`
        this.item.longitude
        navigator.clipboard.writeText(url)
        this.$mcToast.info(this.$t('global.alert.text.linkCopied'), {
          position: 'top-center',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: 'button',
          icon: false,
          rtl: false,
        })
      } else if (param === 'tempTracker') {
        this.$bvModal.hide('modal-share')
        this.$bvModal.show('modal-temp-tracker')
      }
    },
    setAccessToken(result) {
      this.tempTracking = result
    },
  },
}
</script>
